// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2NM0X","title":"styles_title__Tz9Xc"};